import { useState, useEffect } from "react"

/**
 * Hook to detect if the current viewport is mobile size
 * @param {number} breakpoint - The width breakpoint for mobile (default: 991)
 * @returns {boolean} - True if viewport width <= breakpoint
 */
const useIsMobile = (breakpoint = 991) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth <= breakpoint)

    checkIsMobile()
    window.addEventListener("resize", checkIsMobile)

    return () => window.removeEventListener("resize", checkIsMobile)
  }, [breakpoint])

  return isMobile
}

export default useIsMobile
